import { createSlice, SliceCaseReducers } from "@reduxjs/toolkit";
import { iSession } from "../../interfaces/session";
import SESSION from "./state";


export const sSession = createSlice<iSession, SliceCaseReducers<iSession>, 'session'>({
    name: 'session',
    initialState: SESSION,
    reducers: {
        _setRoute: (store, action) => void(store.route = action.payload),
        _setProfessions: (store, action) => void(store.professions = action.payload),
    }
})

export default sSession.reducer;
/** Exporto las acciones de redux */
export const { _setRoute, _setProfessions } = sSession.actions